import React from "react";
import Layout from "../Layout";
import TWH2 from "../../../assets/hero11.png";
import offer from "../../../assets/offer.png";
import Iterator from "../../utils/Iterator";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import {
  Brush,
  ChartNoAxesColumn,
  Code,
  Languages,
  LayoutGrid,
  MessageSquare,
  MonitorSmartphone,
  Palette,
  PanelTop,
  Repeat,
  ScanQrCode,
  Search,
} from "lucide-react";
import { FaHandFist } from "react-icons/fa6";
import { motion } from "framer-motion";
import kyoto from "../../../assets/Partners/kyoto.jpg";
import hail from "../../../assets/Partners/hail.jpg";
import pizzamaker from "../../../assets/Partners/THE.png";
import homeMade from "../../../assets/Partners/homeMade.png";
import shahabander from "../../../assets/Partners/shahbander.jpg";
import { indexStore } from "../../../store/indexStore";
import UAEDirhamIcon from "../../utils/UAEDirhamIcon";

function HomePage() {
  const { t } = useTranslation();

  return (
    <Layout title={`TWh Menu`}>
      <div className=" pb-7 pt-2 flex flex-col gap-5">
        <HeroSection t={t} />
        <OfferSection t={t} />
        <FeaturesSection t={t} />
        <PartnersSection t={t} />
        <ServicesSection t={t} />
      </div>
    </Layout>
  );
}

export default HomePage;

const HeroSection = ({ t }: any) => {
  return (
    <section className=" px-4 py-2 flex flex-col-reverse gap-7 md:flex-row  justify-between md:items-center">
      <div className="md:max-w-maxWidthHalf flex flex-col gap-3">
        <h2 className="text-4xl font-bold whitespace-pre-line">
          {t("HomePage.introduction")}
        </h2>
        <p className="text-sm  whitespace-pre-line">
          {t("HomePage.introductionParagraph")}
        </p>
        <Button variant={"default"} className="bg-MainBlue text-white">
          {t("pages.getStarted")}
        </Button>
      </div>
      <div className="flex justify-center items-center md:w-1/3">
        <img className="m-auto" src={TWH2} alt="Hero" />
      </div>
    </section>
  );
};
const OfferSection = ({ t }: any) => {
  return (
    <section className=" py-2 flex flex-col gap-7  justify-between">
      <section className="bg-muted grid grid-cols-1 md:grid-cols-2 gap-4 items-center px-4 py-10 rounded mb-2">
        {/* النص */}
        <div className="order-2 md:order-1 flex flex-col text-center items-center md:items-start gap-4">
          <h2 className="text-3xl font-bold mb-4">{t("gloabl.getOfferNow")}</h2>
          <p className=" hidden md:block text-xl max-w-2xl mb-6">
            {t("gloabl.getUpTo")}
          </p>

          <div className="flex flex-col gap-4">
            <div className="flex flex-col md:flex-row gap-2">
              <span className="text-2xl line-through text-gray-400">
                {t("gloabl.AED")} 119
              </span>
              <span className="text-4xl font-bold text-MainBlue">
                {t("gloabl.AED")}65
              </span>
            </div>
            <div className="flex justify-end items-end gap-4">
              <span className="text-2xl text-white p-3 bg-MainBlue rounded-full">
                45% off
              </span>
            </div>
          </div>

          <a
            href="whatsapp://send?phone=+971528401112&text=Hello%21+I+found+TWHMENU.com+and+I+want+to+create+digital+menu"
            dir="ltr"
            target="_blank"
            rel="noreferrer"
            className="mt-8 w-1/2 text-center px-6 py-3 bg-MainBlue text-onPrimary font-semibold rounded hover:bg-yellow-600 transition duration-300"
          >
            {t("gloabl.getOffer")}
          </a>
        </div>

        {/* الصورة */}
        <div className="order-1 md:order-2 flex-1 flex justify-center items-center bg-muted">
          <img className="w-full " src={offer} alt="Hero" />
        </div>
      </section>
      <motion.div
        variants={ServiceItem}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        className="grid grid-cols-1 md:grid-cols-2  p-4 gap-6"
      >
        {/* بطاقة الخطة الشهرية */}
        <div className="rounded-2xl order-2 border text-center border-gray-200 p-6 flex flex-col shadow-sm hover:shadow-md transition">
          <h3 className="text-lg font-semibold mb-2">
            {t("Pricing.monthlyPlanTitle")}
          </h3>
          <p className="text-2xl font-bold">
            <span dir="ltr" className="">
              <UAEDirhamIcon className="w-4 h-4 inline-block" /> 95
            </span>
            <span className="text-sm font-medium">
              /{t("Pricing.perMonth")}
            </span>
          </p>
          <p className="text-gray-500 mt-1 line-through text-sm">
            <span dir="ltr" className="">
              <UAEDirhamIcon className="w-4 h-4 inline-block" /> 119
            </span>
            /{t("Pricing.perMonth")}
          </p>
          <span className="mt-4 inline-block bg-blue-500 text-white py-2 px-4 rounded-lg font-semibold text-center">
            {t("gloabl.details")}
          </span>
        </div>

        {/* بطاقة الخطة السنوية */}
        <div className="rounded-2xl order-1 text-center border-2 border-blue-500 p-6 flex flex-col shadow-md relative hover:shadow-lg transition">
          <span className="absolute top-2 right-2 bg-blue-500 text-white text-xs font-semibold px-2 py-1 rounded-full">
            {t("Pricing.bestValue")}
          </span>
          <h3 className="text-lg font-semibold mb-2">
            {t("Pricing.yearlyPlanTitle")}
          </h3>
          <p className="text-2xl font-bold">
            <span dir="ltr" className="">
              <UAEDirhamIcon className="w-4 h-4 inline-block" /> 780
            </span>
            <span className="text-sm font-medium">/{t("Pricing.perYear")}</span>
          </p>
          <p className="text-gray-500 mt-1 line-through text-sm">
            <span dir="ltr" className="">
              <UAEDirhamIcon className="w-4 h-4 inline-block" /> 1140
            </span>
            /{t("Pricing.perYear")}
          </p>
          <a
            href="/pricing"
            className="mt-4 inline-block bg-blue-500 text-white py-2 px-4 rounded-lg font-semibold text-center"
          >
            {t("gloabl.details")}
          </a>
        </div>
      </motion.div>
    </section>
  );
};
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2, // يخلي العناصر تظهر واحد واحد
    },
  },
};

const FeaturesItem = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};
const FeaturesSection = ({ t }: any) => {
  const featuresList = features(t);

  return (
    <section className="px-4 py-2 flex flex-col gap-8  justify-between items-center">
      <div className="flex flex-col gap-3  justify-between items-center">
        <h1 className="text-4xl font-bold">{t("HomePage.KeyFeatures")}</h1>
        <p className="text-sm text-secondary-foreground text-center">
          {t("HomePage.discribeFeatures")}
        </p>
      </div>
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show" // ✅ يظهر فقط عند scroll
        viewport={{ once: true, amount: 0.2 }}
        className="grid grid-cols-2 md:grid-cols-3 gap-4"
      >
        <Iterator
          data={featuresList}
          render={(e, i) => (
            <motion.div
              key={i}
              variants={FeaturesItem}
              className="flex flex-col gap-3"
            >
              <div className="flex">
                <div className="text-3xl flex text-MainBlue p-4 items-center bg-muted rounded-full">
                  {e.icon}
                </div>
              </div>
              <h3 className="text-lg font-bold">{e.name}</h3>
              <p className="text-base text-secondary-foreground">
                {e.description}
              </p>
            </motion.div>
          )}
        />
      </motion.div>
    </section>
  );
};
const ServiceItem = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const ServicesSection = ({ t }: any) => {
  const services = [
    {
      icon: <Code className="text-5xl text-MainBlue" />,
      text: t("HomePage.webDevelopment"),
    },
    {
      icon: <PanelTop className="text-5xl text-MainBlue" />,
      text: t("HomePage.paymentLinks"),
    },
    {
      icon: <Search className="text-5xl text-MainBlue" />,
      text: t("HomePage.seo"),
    },
    {
      icon: <Palette className="text-5xl text-MainBlue" />,
      text: t("HomePage.graphicDesign"),
    },
  ];
  return (
    <section className="px-4 py-10 flex flex-col gap-8  ">
      <div className="flex flex-col gap-3  justify-between items-center">
        <h1 className="text-4xl font-bold">{t("HomePage.AdvancedSerives")}</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 ">
        <Iterator
          data={services}
          render={(s, i) => (
            <motion.div
              key={i}
              variants={ServiceItem}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              className="bg-muted rounded-lg flex flex-col font-bold gap-3 p-8 justify-between items-center"
            >
              {s.icon}
              <p className="text-2xl text-center">{s.text}</p>
            </motion.div>
          )}
        />
      </div>
    </section>
  );
};

const PartnersSection = ({ t }: any) => {
  const Partners = [
    {
      image: hail,
      url: "https://twhmenu.com/hail/1//",
    },
    {
      image: kyoto,
      url: "https://twhmenu.com/kyoto/16",
    },
    {
      image: pizzamaker,
      url: "https://twhmenu.com/thepizzamaker/32",
    },
    {
      image: homeMade,
      url: "https://twhmenu.com/HOMEMADEPIZZA/33",
    },
    {
      image: shahabander,
      url: "https://twhmenu.com/SHAHABANDARMANDI",
    },
  ];
  const { lang } = indexStore();
  const isRTL = lang === "ar" ? true : false;

  return (
    <section className="px-4 py-10 bg-muted  flex flex-col gap-7 justify-between ">
      <div className=" flex flex-col gap-3">
        <h2 className="text-4xl font-bold text-center whitespace-pre-line">
          {t("HomePage.ourPartners")}
        </h2>
      </div>

      <div className="overflow-hidden relative group">
        <div
          className={`flex w-max ${
            isRTL ? "animate-marqueertl" : "animate-marquee"
          } group-hover:[animation-play-state:paused]`}
        >
          {[...Partners, ...Partners].map((p, i) => (
            <a
              key={i}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 w-32 sm:w-40 md:w-48 mx-4"
            >
              <img
                src={p.image}
                alt=""
                className="w-full h-auto object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
const features = (t: any) => [
  {
    name: t("HomePage.EasyCustomization"),
    icon: <Brush />,
    description: t("HomePage.EasyCustomizationParagraph"),
  },
  {
    name: t(`HomePage.InstantQRCodeAccess`),
    icon: <ScanQrCode />,
    description: t(`HomePage.InstantQRCodeAccessParagraph`),
  },
  {
    name: t("HomePage.ResponsiveDesign"),
    icon: <MonitorSmartphone />,
    description: t("HomePage.ResponsiveDesignParagraph"),
  },
  {
    name: t("HomePage.RealtimeUpdates"),
    icon: <Repeat />,
    description: t("HomePage.RealtimeUpdatesParagraph"),
  },
  {
    name: t("HomePage.MenuAnalytics"),
    icon: <ChartNoAxesColumn />,
    description: t("HomePage.MenuAnalyticsParagraph"),
  },
  {
    name: t("HomePage.CustomerFeedback"),
    icon: <MessageSquare />,
    description: t("HomePage.customerFeedbackParagraph"),
  },
  {
    name: t("HomePage.MultiLanguageSupport"),
    icon: <Languages />,
    description: t("HomePage.multiLanguageSupportParagraph"),
  },
  {
    name: t("HomePage.DynamicLayouts"),
    icon: <LayoutGrid />,
    description: t("HomePage.dynamicLayoutsParagraph"),
  },
  {
    name: t("HomePage.PremiumSupport"),
    icon: <FaHandFist />,
    description: t("HomePage.premiumSupportParagraph"),
  },
];
